module.exports = __webpack_public_path__ + "static/highschool-1-fd402fed7477c487b6316b41e67dbdde.jpg";